// ------SAMPLE CALLS------

import {
  getBranch,
  getKey,
  getToken,
  getUser,
} from "../../../../Components/Helpers/Utilities/Common";
import { formatDateWithTimeHMS } from "../../../../Helpers/Utils/Common";
import {
  getAPICall,
  postAPICallwithFile,
  putAPICall,
  postAPICall,
  getWithParamsAPICall,
} from "../../../../Components/Helpers/API/axiosMethodCall";

// CREATE VITAL SIGN
export const createVital = async (info, patient_id, queue_id = null) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "vital_signs/create",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patient_id,
        queue_id: queue_id,
        date: info.date || "",
        weight: info.weight || "",
        weight_in_lb: info.weight_in_lb || "",
        height: info.height || "",
        height_in_inch: info.height_in_inch || "",
        height_in_ft: info.height_in_ft || "",
        bmi: info.bmi || "",
        ibw: info.ibw || "",
        waist: info.waist || "",
        hip: info.hip || "",
        whr: info.whr || "",
        temperature: info.temperature || "",
        bp: info.bp || "",
        heart_rate: info.heart_rate || "",
        respiratory_rate: info.respiratory_rate || "",
        oxygen_saturation: info.oxygen_saturation || "",
        left_eye_w_correction: info.left_eye_w_correction || "",
        right_eye_w_correction: info.right_eye_w_correction || "",
        left_eye_wo_correction: info.left_eye_wo_correction || "",
        right_eye_wo_correction: info.right_eye_wo_correction || "",
        blood_type: info.blood_type || "",
        // last_meal:
        //   info.last_meal !== "" ? formatDateWithTimeHMS(info.last_meal) : "",
        length: info.length || "",
        head_circumference: info.head_circumference || "",
        skinfold_thickness: info.skinfold_thickness || "",
        body_circumference_waist: info.body_circumference_waist || "",
        hip_in_cm: info.hip_in_cm || "",
        limbs: info.limbs || "",
        muac: info.muac || "",

        chief_complaint: info.chief_complaint || "",
        complaint_2: info.complaint_2,
        complaint_3: info.complaint_3,
        complaint_4: info.complaint_4,
        complaint_5: info.complaint_5,
        complaint_6: info.complaint_6,
        complaint_8: info.complaint_8,

        menarche_period: info.menarche_period || "",
        last_mens_period: info.last_mens_period || "",
        period_duration: info.period_duration || "",
        mens_interval: info.mens_interval || "",
        pads_per_day: info.pads_per_day || "",
        onset_sex_ic: info.onset_sex_ic || "",
        birth_ctrl_method: info.birth_ctrl_method || "",
        is_menopause: info.is_menopause || "",
        menopause_age: info.menopause_age || "",
        // first_mens_period: info.first_mens_period,
        // last_mens_period: info.last_mens_period,
        // preg_count: info.preg_count,
        general_survey: info.general_survey,
      }
    );
    return response;
  } catch (error) {
    return error;
  }
};

// CREATE OB PROFILE
export const createOBProfile = async (info, patient_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "ob_profiles/create",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patient_id,
        menarche_period: info.menarche_period || "",
        last_mens_period: info.last_mens_period || "",
        period_duration: info.period_duration || "",
        mens_interval: info.mens_interval || "",
        pads_per_day: info.pads_per_day || "",
        onset_sex_ic: info.onset_sex_ic || "",
        birth_ctrl_method: info.birth_ctrl_method || "",
        is_menopause: info.is_menopause || "",
        menopause_age: info.menopause_age || "",
      }
    );
    return response;
  } catch (error) {
    return error;
  }
};
// UPDATE VITAL SIGN
export const editVital = async (info, patient_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "vital_signs/update",
      {
        requester: getUser(),
        token: getToken(),
        patient_id,
        weight: info.weight || "",
        weight_in_lb: info.weight_in_lb || "",
        height: info.height || "",
        height_in_inch: info.height_in_inch || "",
        height_in_ft: info.height_in_ft || "",
        bmi: info.bmi || "",
        ibw: info.ibw || "",
        waist: info.waist || "",
        hip: info.hip || "",
        whr: info.whr || "",
        temperature: info.temperature || "",
        bp: info.bp || "",
        heart_rate: info.heart_rate || "",
        respiratory_rate: info.respiratory_rate || "",
        oxygen_saturation: info.oxygen_saturation || "",
        left_eye_w_correction: info.left_eye_w_correction || "",
        right_eye_w_correction: info.right_eye_w_correction || "",
        left_eye_wo_correction: info.left_eye_wo_correction || "",
        right_eye_wo_correction: info.right_eye_wo_correction || "",
        blood_type: info.blood_type || "",
        vital_sign_id: info.id,
        // last_meal: formatDateWithTimeHMS(info.last_meal) || "",
        length: info.length || "",
        head_circumference: info.head_circumference || "",
        skinfold_thickness: info.skinfold_thickness || "",
        body_circumference_waist: info.body_circumference_waist || "",
        hip_in_cm: info.hip_in_cm || "",
        limbs: info.limbs || "",
        muac: info.muac || "",
      }
    );
    return response;
  } catch (error) {
    return error;
  }
};
export const deleteVitalSign = async (vital_sign_id) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      vital_sign_id,
    };

    const response = await postAPICall(
      process.env.REACT_APP_LINK + "vital_signs/delete",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

// CREATE FPE
export const createFPE = async (info, patient_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "fpe_forms/create",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patient_id,
        chief_complaint: info.chief_complaint,
        complaint_2: info.complaint_2,
        complaint_3: info.complaint_3,
        complaint_4: info.complaint_4,
        complaint_5: info.complaint_5,
        complaint_6: info.complaint_6,
        complaint_8: info.complaint_8,
        first_mens_period: info.first_mens_period,
        last_mens_period: info.last_mens_period,
        preg_count: info.preg_count,
        general_survey: info.general_survey,

        weight: info.weight,
        weight_in_lb: info.weight_in_lb,
        height: info.height,
        height_in_ft: info.height_in_ft,
        height_in_inch: info.height_in_inch,
        bmi: info.bmi,
        ibw: info.ibw,
        waist: info.waist,
        hip: info.hip,
        whr: info.whr,
        temperature: info.temperature,
        bp: info.bp,
        heart_rate: info.heart_rate,
        respiratory_rate: info.respiratory_rate,
        oxygen_saturation: info.oxygen_saturation,
        left_eye_w_correction: info.left_eye_w_correction || "",
        right_eye_w_correction: info.right_eye_w_correction || "",
        left_eye_wo_correction: info.left_eye_wo_correction || "",
        right_eye_wo_correction: info.right_eye_wo_correction || "",
        last_meal: info.last_meal,
        length: info.length,
        head_circumference: info.head_circumference,
        skinfold_thickness: info.skinfold_thickness,
        body_circumference_waist: info.body_circumference_waist,
        hip_in_cm: info.hip_in_cm,
        limbs: info.limbs,
        muac: info.muac,

        blood_type: info.blood_type,
        smoking_year: info.smoking_year,
        drinking_year: info.drinking_year,
        illicit_drugs: info.illicit_drugs,
        is_sexually_active: info.is_sexually_active,
        has_family_planning: info.has_family_planning,
        menarche: info.menarche,
        period_duration: info.period_duration,
        gravidity: info.gravidity,
        parity: info.parity,
        delivery_type: info.delivery_type,
        menopause_age: info.menopause_age,

        past_med_history: info.past_med_history,
        fam_past_med_history: info.fam_past_med_history,
        allergies: info.allergies,
        cancers: info.cancers,
        past_med_history_others: info.past_med_history_others,
        hepatitis_type: info.extrapulmonary_tuberculosis_category,
        highest_bp: info.highest_bp,
        pulmonary_tuberculosis_category:
          info.extrapulmonary_tuberculosis_category,
        extrapulmonary_tuberculosis_category:
          info.extrapulmonary_tuberculosis_category,

        family_allergies: info.family_allergies,
        family_cancers: info.family_cancers,
        fam_past_med_history_others: info.fam_past_med_history_others,
        family_hepatitis_type: info.family_hepatitis_type,
        family_highest_bp: info.family_highest_bp,
        family_pulmonary_tuberculosis_category:
          info.family_pulmonary_tuberculosis_category,
        family_extrapulmonary_tuberculosis_category:
          info.family_extrapulmonary_tuberculosis_category,
      }
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getVitalSigns = async (patient_id) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      patient_id,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "vital_signs/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const getUsers = async (data, ref, num) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "users/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const getUserID = async (user_id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "users/get/?user_id=" + user_id,
      {
        requester: getUser(),
        token: getToken(),
        user_id: user_id,
      }
    );
    return { data: response.data.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const editUser = async (info) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "users/update",
      {
        requester: getUser(),
        token: getToken(),
        user_id: info.id,
        username: info.username,
        full_name: info.full_name,
        role_id: info.role_id,
        role_name: info.role_name,
      }
    );

    return { data: response };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const editPassword = async (info) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "users/update",
      {
        requester: getUser(),
        token: getToken(),
        username: info.username,
        user_id: info.id,
        password: info.password,
      }
    );

    return { data: response };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const deleteUser = async (id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "users/delete",
      {
        requester: getUser(),
        token: getToken(),
        user_id: id,
      }
    );
    return { data: response };
  } catch (error) {
    return { error: error.response };
  }
};
